import React from 'react'
import _ from 'lodash'
import { List } from 'immutable'
import { connect } from 'react-redux'
import { getSelectedStore, getMyStores } from 'x/redux/selectors'

// import api from 'x/utils/api'
import * as util from 'x/utils/util'
import * as acl from 'x/utils/acl'
import CONS from 'x/config/constants'
import { COLORS, S } from 'x/config/styles'
import p from 'x/config/platform-specific'

import VStack from 'xui/components/VStack'
import HStack from 'xui/components/HStack'
import XText from 'xui/components/XText'
import XInput from 'xui/components/XInput'
import XIconButton from 'xui/components/XIconButton'
import {
  IMultipleStoresProductVariantListViewProps,
  IMultipleStoresProductVariantListViewState,
  ISearchProductItem,
  IProductListFilterTemplate,
  ICategory,
  IBarcodeScannerOutput,
  IProductVariantType,
} from 'x/types'
import { FlatList, ListRenderItemInfo, RefreshControl, TextInput, TouchableOpacity } from 'react-native'
import * as api from 'x/utils/api'
import Box from 'xui/components/Box'
import XSpinner from 'xui/components/XSpinner'
import ErrorListItem from 'xui/components/ErrorListItem'
import XIcon from 'xui/components/XIcon'

import * as NavActions from 'x/utils/navigation'
import ProductVariantListFilterTemplateSelector from 'xui/components/product/ProductVariantListFilterTemplateSelector'
import { diff } from 'deep-object-diff'
import ProductCategorySelector from 'xui/components/product/ProductCategorySelector'
import SearchProductVariantListItem from 'xui/components/product/SearchProductVariantListItem'
import BarcodeScannerModalButton from 'xui/components/BarcodeScannerModalButton'
import XOverlay from 'xui/components/XOverlay'
import XCustomHeader from 'xui/components/XCustomHeader'
import XSwitch from 'xui/components/XSwitch'
import XButton from 'xui/components/XButton'
import BaseUIProductVariantListView from './BaseUIProductVariantListView'

// const { NAME, COST, PRICE, PRICE_RETAIL, QTY, AVAILABLE_QTY, WEIGHT, H, SKU, UPC, CATEGORY } = CONS.PRODUCT_ATTR

class MultipleStoresProductVariantListView extends BaseUIProductVariantListView<
  IMultipleStoresProductVariantListViewProps,
  IMultipleStoresProductVariantListViewState
> {
  static displayName = 'MultipleStoresProductVariantListView'

  isListItemReadonly = () => true

  getMyStoreIds = () => {
    const { myStores = List([]) } = this.props
    return myStores.map((store) => store.get('id')).toArray()
  }

  getIsNavToProductDetailDisabled = () => {
    return util.getNavParam(this.props, 'isNavToProductDetailDisabled', true)
  }

  fetchProducts = async (extraParams: any) => {
    const { searchText, currentFilter } = this.state
    // console.log('fetchProducts extraParams => ', extraParams)
    // console.log('fetchProducts searchText => ', searchText)

    // const store_id = util.getNavParam(this.props, 'store_id')
    const seller_store_id = util.getNavParam(this.props, 'seller_store_id')
    const pp_ids = util.getNavParam(this.props, 'pp_ids')
    const excluded_pp_ids = util.getNavParam(this.props, 'excluded_pp_ids')
    // const ug_id = util.getNavParam(this.props, 'ug_id')
    // const pg_ids = util.getNavParam(this.props, 'pg_ids')

    // const queryTextArrayFiltered = searchText.split(/(\s+)/g).filter((str) => str.trim().length > 0)
    // const queryTextArray = queryTextArrayFiltered.slice(0, 12)
    // console.log('fetchProducts currentFilter => ', currentFilter)
    const filterReqBody = util.translateProductListFilterToRequestBody(currentFilter)
    // console.log('fetchProducts filterReqBody => ', filterReqBody)

    if (seller_store_id && filterReqBody && filterReqBody.show_mkp_ch_ids) {
      delete filterReqBody.show_mkp_ch_ids
    }

    const store_ids = this.getMyStoreIds()
    const reqBody = {
      store_ids,
      // store_id,
      // store_id: seller_store_id || store_id,
      offset: 0,
      // limit: CONS.PRODUCTS_FETCH_LIMIT_MORE,
      limit: 20,
      queryText: searchText,

      ...filterReqBody,
    }

    if (_.isNumber(extraParams.offset)) {
      reqBody.offset = extraParams.offset
    }

    if (reqBody.offset === 0) {
      // @ts-ignore c คือขอ total count
      reqBody.c = 1
      reqBody.limit = 15
    }

    if (this.isHelper() && !seller_store_id) {
      // @ts-ignore
      reqBody.is_helper = true
    }

    if (pp_ids && pp_ids.length > 0) {
      reqBody.pp_ids = pp_ids
    }

    if (excluded_pp_ids && excluded_pp_ids.length > 0) {
      reqBody.excluded_pp_ids = excluded_pp_ids
    }

    try {
      // // console.log('fetchProducts reqBody => ', reqBody)
      // // BEGIN TODO: Remove this temp code
      // if (this.isListItemPressable()) {
      //   // หน้า เลือกสินค้าเข้าออเดอร์
      //   reqBody.is_v2 = false
      // } else {
      //   // หน้า รายการสต๊อก
      //   reqBody.is_v2 = true
      // }
      // // END: Remove this temp code

      const res = await api.searchInventoryProductsInStores(reqBody)

      // console.log('fetchProducts res => ', res)
      // this.isFetching = false
      // return res

      // if (res.c) {
      //   await util.setStatePromise(this, { productCount: res.c })
      // }

      let productCount
      let newProducts
      const newState: Partial<IMultipleStoresProductVariantListViewState> = {}

      if (res.count) {
        // await util.setStatePromise(this, { productCount: res.count })
        productCount = res.count
        newState.productCount = productCount
      }

      if (res.products) {
        const { products } = this.state
        // await util.setStatePromise(this, { products: products.concat(res.products) })
        newProducts = products.concat(res.products)
        newState.products = newProducts
      }

      await util.setStatePromise(this, newState)

      const onSearchSuccess = util.getNavParam(this.props, 'onSearchSuccess')
      if (_.isFunction(onSearchSuccess)) {
        onSearchSuccess(searchText, newProducts, productCount)
      }
    } catch (err) {
      console.log('fetchProducts err => ', err)
      if (reqBody.offset === 0) {
        await util.setStatePromise(this, { fetchErrorMessage: util.getErrorMessageFromErrorResponse(err) })
      }
    }
  }

  _setupFilter = async () => {
    const defaultFilter = util.getNavParam(this.props, 'defaultFilter', {}) as IProductListFilterTemplate
    const ug_id = util.getNavParam(this.props, 'ug_id')
    const pg_ids = util.getNavParam(this.props, 'pg_ids')
    const seller_store_id = util.getNavParam(this.props, 'seller_store_id')

    if (!_.has(defaultFilter, 'searchText')) {
      defaultFilter.searchText = ''
    }

    if (_.isNumber(ug_id)) {
      defaultFilter.selectedUserGroupId = ug_id
    }

    if (_.isArray(pg_ids) && pg_ids.length > 0) {
      defaultFilter.selectedProductGroupIds = pg_ids
    }

    if (_.isNumber(seller_store_id)) {
      defaultFilter.sellerStoreId = seller_store_id
    }

    if (this._isSelectedStoreHasMkpChannels()) {
      defaultFilter.isMkpShow = true
    }

    await util.setStatePromise(this, { defaultFilter, currentFilter: defaultFilter, searchText: defaultFilter.searchText })
  }

  _navToProductVariantListFilterView = () => {
    const { navigation } = this.props
    const { defaultFilter, currentFilter, searchText } = this.state

    const ug_id = util.getNavParam(this.props, 'ug_id')
    const pg_ids = util.getNavParam(this.props, 'pg_ids')
    const seller_store_id = util.getNavParam(this.props, 'seller_store_id')

    navigation.dispatch(
      NavActions.navToProductVariantListFilterView({
        store_id: util.getNavParam(this.props, 'store_id'),
        defaultSetting: defaultFilter,
        appliedSetting: { ...currentFilter, searchText },
        onSubmit: this._onSubmitFilter,
        ug_id,
        pg_ids,
        seller_store_id,

        isHiddenProductTemplate: true,
        isHiddenMkpFilterCard: true,
        isHiddenPriceFilterCard: true,
        isHiddenCostFilterCard: true,
        isHiddenCategoryFilterCard: true,
      })
    )
  }

  _renderTitleText = () => {
    // const { selectedStore } = this.props
    // let targetStoreName = selectedStore.get('name')
    const titleFromNavParam = util.getNavParam(this.props, 'title', 'รายการสต๊อกของทุกร้าน')

    return (
      <XText bold textAlignVertical='center' numberOfLines={2}>
        {titleFromNavParam}
      </XText>
    )
  }

  _renderHeader = () => {
    const { isInitialized, isUICategoryHiden, isUIFilterHiden, isUISearchHiden, isUIProductTypeHidden, selectedVisibilityControl } =
      this.state
    // if (!isInitialized) {
    //   return null
    // }

    const isGoBackButtonHidden = util.getNavParam(this.props, 'isGoBackButtonHidden', false)

    return (
      <VStack w='full' borderBottomWidth='1' borderBottomColor='gray.300'>
        <HStack w='full' minH={isUISearchHiden ? '44px' : undefined} px='2' space='1' bg='white' alignItems='center'>
          {isGoBackButtonHidden ? null : <XIconButton name='arrow-back' onPress={this._goBack} />}
          {/* <XIconButton name='arrow-back' onPress={this._goBack} /> */}

          <HStack flex={1} alignItems='center' justifyContent='flex-start' flexWrap='wrap'>
            {this._renderTitleText()}
          </HStack>

          {isUIFilterHiden ? null : (
            <HStack alignItems='center' space='1'>
              {this._renderRefreshButton()}
              {/* {this._renderVisibilityControlButton()} */}
              {/* {this.renderFilterTemplateIcon()} */}
              {this._renderFilterIconButton()}
              {/* <XIconButton family='MaterialCommunityIcons' name='filter' onPress={this._navToProductVariantListFilterView} /> */}
            </HStack>
          )}
        </HStack>

        {/* {!isInitialized || isUIFilterHiden ? null : this.renderFilterTemplateBar()} */}

        {isUISearchHiden ? null : (
          <HStack w='full' px='2' py='0.5' space='2' bg='white'>
            <HStack flex={1}>
              {this._renderBarcodeScannerModalButton()}
              <HStack flex={1}>
                {this._renderSearchInput()}
                <HStack w='32px' alignItems='center' justifyContent='center' position='absolute' left='0' top='0' bottom='0'>
                  <XIcon inactive name='search' />
                </HStack>
              </HStack>
              {this._renderCloseSearchButton()}
            </HStack>
          </HStack>
        )}

        {!isInitialized || isUISearchHiden ? null : this._renderSearchInfoBar()}
        {/* {!isInitialized || isUICategoryHiden || !selectedVisibilityControl.isCategoryVisible ? null : this._renderCatListBar()} */}
        {!isInitialized || isUIProductTypeHidden || !selectedVisibilityControl.isProductVariantTypeVisible
          ? null
          : this._renderProductVariantTypeBar()}
        {this._renderListItemEditedWarning()}
      </VStack>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
    myStores: getMyStores(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(MultipleStoresProductVariantListView)
